import React from 'react';
import { Box, Skeleton } from '@mui/material';
const FlightResultSkeleton = () => {
	return (
		<Box
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				borderRadius: 4,
				background: '#fff',
				filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
				padding: 30,
				marginTop: 10,
			}}>
			<Box>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={80}
					height={12}
					style={{ borderRadius: 25 }}
				/>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={50}
					height={12}
					style={{ borderRadius: 25, marginTop: 5 }}
				/>
			</Box>
			<Box>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={250}
					height={12}
					style={{ borderRadius: 25 }}
				/>{' '}
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={350}
					height={12}
					style={{ borderRadius: 25, marginTop: 10 }}
				/>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={180}
					height={12}
					style={{ borderRadius: 25, marginTop: 10 }}
				/>
			</Box>

			<Box>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={100}
					height={12}
					style={{ borderRadius: 25 }}
				/>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={100}
					height={12}
					style={{ borderRadius: 25, marginTop: 10 }}
				/>
			</Box>

			<Box>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={100}
					height={12}
					style={{ borderRadius: 25 }}
				/>
				<Skeleton
					animation='wave'
					variant='rectangular'
					width={100}
					height={12}
					style={{ borderRadius: 25, marginTop: 10 }}
				/>
			</Box>
		</Box>
	);
};

export default FlightResultSkeleton;
